import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiUri, filterRequest } from "../../utilities/apiManager";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getOtps = createAsyncThunk(
  "otps/getOtps",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axios.get(
        `${apiUri}/requests/otp?page=${page}&size=${size}&query=${query}${filter}`,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": document.documentElement.lang,
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateOtp = createAsyncThunk(
  "otps/updateOtp",
  async (args, thunkApi) => {
    try {
      const { data } = await axios.put(
        `${apiUri}/requests/otp/${args._id}`,
        {
          status: args.status,
          reason: args.reason,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": document.documentElement.lang,
            "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
          },
        }
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const getOtpById = createAsyncThunk(
  "otps/getOtpById",
  async (id, thunkApi) => {
    try {
      const { data } = await axios.get(`${apiUri}/requests/otp/${id}`, {
        headers: {
          "Content-Type": "application/json",
          "Accept-Language": document.documentElement.lang,
          "auth-token": "Bearer " + thunkApi.getState().auth.accessToken,
        },
      });
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const otpsSlice = createSlice({
  name: "otps",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getOtps.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getOtps.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      // Handle both possible API response structures
      state.data = payload.data?.data || payload.data || [];
      state.pages = payload.data?.pages || payload.pages || 0;
      state.itemsCount = payload.data?.itemsCount || payload.itemsCount || 0;
      state.error = null;
    });
    builder.addCase(getOtps.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message;
    });

    builder.addCase(updateOtp.pending, (state) => {
      state.isLoading = true;
      // state.error = null;
    });
    builder.addCase(updateOtp.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      // const indexAt = state.data.findIndex((el) => el._id === payload.data._id);
      // state.data[indexAt] = payload.data;
      // state.error = null;
    });
    builder.addCase(updateOtp.rejected, (state, { payload }) => {
      state.isLoading = false;
      // state.error = payload?.message;
    });

    builder.addCase(getOtpById.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(getOtpById.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.error = null;
    });
    builder.addCase(getOtpById.rejected, (state, { payload }) => {
      state.isLoading = false;
      state.error = payload?.message;
    });
  },
});

export default otpsSlice.reducer;
